import React, { useState, useEffect } from 'react'

import _ from 'lodash';
import cx from "classnames";
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';
import Select, { components } from 'react-select';
import shortid from 'shortid';
import { IKImage } from "imagekitio-react";
import dateformat from "dateformat";
import { SuccessToast } from 'components/Toast';
import { toast } from 'react-toastify';
import Truncate from "react-truncate";
import { Image, Button, Badge, Form, Popover, OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './components.module.scss';
import FileService from 'services/file.service';
import { INTERACTIVE_CONTENT_TYPES } from 'constants/storyboardType';

const defaultContentImage = '/public/cleverstory/v2/static/default_card.jpg';

export const FormHeader = ({ className, title, discription }) => {
  return (
    <div className={cx(styles.formHeader, className)}>
      <span className={styles.title} >{title}</span>
      <span className={styles.discription} >{discription}</span>
    </div>
  )
}

export const SmallContentCard = ({ content, className, key }) => {

  var name = _.get(content, 'name') || "";
  var iconUrl = _.get(content, 'icon.key') || _.get(content, 'icon.url');

  return (
    <div key={key} className={cx(styles.smallAssetCardWrapper, className)}>
      <div className={styles.iconWrapper}>
        <IKImage
          className={styles.icon}
          path={iconUrl || defaultContentImage}
        />
      </div>
      <div className={styles.detailsContainer}>
        <span className={styles.name}>
          {name}
        </span>
        <ContentMetadata content={content} />
      </div>
    </div>
  )
}

export const MultiContentCard = ({ className, key }) => {

  return (
    <div key={key} className={cx(styles.smallAssetCardWrapper, className)}>
      <div className={styles.smallIconWrapper}>
        <Image
          className={styles.icon}
          src={`${process.env.REACT_APP_UI_URL}/images/multidoc.svg`}
        />
      </div>
      <div className={styles.detailsContainer}>
        <span className={styles.name}>
          Multiple Asset
        </span>
      </div>
    </div>
  )
}

export const CustomFieldsDropDown = ({ field, customFieldValue, handleOnChange }) => {

  const multiSelector = _.get(field, 'multiselect');
  const customOptions = _.map(_.get(field, 'options'), item => {
    return {
      ...item,
      value: _.get(item, 'id'),
      label: <TruncatedTextWithTooltip content={_.get(item, 'value')} maxWidth={240} placement='top'/>
    };
  });

  var selectedValue = (customFieldValue && customFieldValue.value || []).map(data => {
    return {
      id: _.get(data, 'id'),
      value: _.get(data, 'id'),
      label: _.get(data, 'value')
    };
  });

  if (!multiSelector) {
    selectedValue = customFieldValue && _.size(customFieldValue.value) > 0 ? { value: _.get(_.head(customFieldValue.value), 'id'), label: _.get(_.head(customFieldValue.value), 'value') } : null;
  }

  const CustomSearchIndicator = (props) => {
    return (
      <i className={cx(styles.icon, 'cleverstory-drop-down')} />
    );
  };

  const RemoveIcon = (props) => {
    return (
      <components.MultiValueRemove {...props}>
        <i className={cx(styles.closeIcon, 'cleverstory-close')} />
      </components.MultiValueRemove>
    );
  };

  const getComputedValue = (value) => {
    if (_.isArray(value)) {
      return _.map(value, (option) => {
        return {
          id: option.value,
          value: option.label
        }
      })
    }

    return {
      id: _.get(value, 'value', ''),
      value: _.get(value, 'label', '')
    }
  }

  const onChange = (value) => {
    if (!value) {
      return;
    }

    var selectedOption = getComputedValue(value)
    handleOnChange(field, selectedOption)
  }

  return (
    <Select
      placeholder="Choose Values"
      className={styles.customSelectDropdown}
      key={field.id}
      components={{ DropdownIndicator: CustomSearchIndicator, MultiValueRemove: RemoveIcon }}
      isClearable={false}
      onChange={onChange}
      value={selectedValue || ''}
      isMulti={multiSelector}
      options={customOptions}
    />
  )
}

export const AssetUploaderFooter = ({ handleClose, handleSave, uploadedAssets, updating, className, isNotPaperfliteAssest = false }) => {

  return (
    <div className={cx(styles.footer, className)}>
      <div className={styles.actionContainer}>
        <Button
          size="sm"
          variant="secondary"
          onClick={() => { handleClose() }}
          // disabled={updating}
          className={styles.cancelButton}
        >
          Close
        </Button>

        <Button className={styles.saveButton}
          onClick={handleSave}
          size="sm"
          variant="primary"
          disabled={_.size(uploadedAssets) == 0 && isNotPaperfliteAssest}
        >
          Add & Close
        </Button>
      </div>
    </div>
  )
}

export const ContentMetadata = ({ content, className, getContentForFieldSelector }) => {
  const metaData = _.get(content, 'metadata', {})
  let fileMetaData = FileService.fileMetaData(metaData);
  let entityType =  _.get(content, 'entityType');
  let storyboardType = _.get(content, 'storyboardType');


  const renderStoryboardType = (type) => {
    if (type === 'LANDING_PAGE') {
      return 'Landing page';
    }
    else if (INTERACTIVE_CONTENT_TYPES.includes(type)) {
      return 'Interactive content';
    }
    else if (type === 'RESOURCE_CENTER') {
      return 'Resource center';
    }
  }

  return (
    <div className={cx(styles.metaData, className)}>
      <div className={styles.type}>
        {entityType != "page" && 
          <>
            <i className={cx(styles.fileIcon, `${FileService.fileIcon(metaData)}`)} />
            <span className={styles.textFormat} >{FileService.fileType(metaData)}</span>
          </>
        }  
        
        {entityType === "page" && 
          <>
            <i className={cx(styles.fileIcon, `${FileService.storyboardIcon(storyboardType)}`)} />
            <span className={styles.storyboardTextFormat} >{renderStoryboardType(storyboardType)}</span>
          </>
        } 
      </div> 
      {fileMetaData && <span className={styles.contentMetadata}>{fileMetaData}</span>}
        <span className={styles.date}>{dateformat(metaData.modified_date, 'dd mmm yyyy')}</span>
    </div>
  );
}


export const ContentUrl = ({ content, className, getContentForFieldSelector, storyboard }) => {
  const metaData = _.get(content, 'metadata', {})
  const entityType = _.get(content, 'entityType') || null;
  const storyboardType = _.get(content, 'storyboardType');

  const fileMetaData = FileService.fileMetaData(metaData);
  let [width, setWidth] = useState(170);

  const contentType  = _.get(metaData, 'content_type');
  const contentUrl =  _.get(metaData, 'url');
  const externalVideo = _.get(content, 'metadata.external_video_provider' || null);

  const modifiedDate = _.get(metaData, 'modified_date') || _.get(content, 'modifiedDate');

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(contentUrl).then(
      () => { },
      () => { }
    )
    toast(
      <SuccessToast
        heading={` `}
        description={"Copied link to clipboard!"}
      />,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
      }
    );
  }

  const calculateWidth = () => {
    switch (externalVideo) {
      case 'vimeo': 
        setWidth(125);
        break;
      case 'wistia': 
        setWidth(125);
        break;
      case 'youtube': 
         setWidth(120);
         break;
      case 'vidyard':
         setWidth(113);
         break;
      default: 
        setWidth(175);
    }
    return;
  }

  const renderStoryboardType = (type) => {
    if (type === 'LANDING_PAGE') {
      return 'Landing page';
    } else if (INTERACTIVE_CONTENT_TYPES.includes(type)) {
      return 'Interactive content';
    } else if (type === 'RESOURCE_CENTER') {
      return 'Resource center';
    }
  }

  return (
    <div className={cx(styles.metaData, className)}>

      <div className={styles.type}>
        {entityType != 'page' &&
          <>
            <i className={cx(styles.fileIcon, `${FileService.fileIcon(metaData)}`)} />
            <span className={styles.textFormat} >{FileService.fileType(metaData)}</span>
          </>
        }
        {entityType == "page" &&
          <>
            <i className={cx(styles.fileIcon, `${FileService.storyboardIcon(storyboardType)}`)} />
            <span className={styles.storyboardTextFormat} >{renderStoryboardType(storyboardType)}</span>
          </>
        }
      </div>
      
      {entityType != "page" && fileMetaData && <span className={styles.contentMetadata}>{fileMetaData}</span>}

      {contentType != "application/url" &&
        <span className={styles.date}>{dateformat(modifiedDate, 'dd mmm yyyy')}</span>
      }

      {contentType === "application/url" &&
        <div className={styles.contentUrl}>
          <OverlayTrigger
            placement="top"
            trigger={["hover", "focus"]}
            overlay={<Tooltip className={styles.tabTooltip} id="button-tooltip">{contentUrl}</Tooltip>}>
              <div className={styles.contentUrl}> 
                <div className={styles.link}>
                  <a className={styles.url} href={contentUrl} target="_blank">
                    <Truncate lines={1} width={width} ellipsis="..." onTruncate={calculateWidth}>
                      {contentUrl}
                    </Truncate>
                  </a>
                </div>
                <div className={styles.copyIcon}> 
                  <i className={cx('cleverstory-copy', styles.icon)} onClick={handleCopyUrl} />
                </div>
              </div>
            </OverlayTrigger>
        </div>
      }
    </div>
  );
}